@use "../styles.module.scss";
@use "../../../config/defaults.module.scss" as defaults;

// Cap the whole column so the banners above the content (newsletter/survey, two year
// offer, renewal notification) line up with the page content instead of overhanging it
// on wide screens (issue #4652). Left-aligned beside the sidebar via .main's margin.
.main {
	max-width: defaults.$contentMaxWidth;
}

.content {
	@apply yst-bg-white yst-rounded-lg yst-transition-transform yst-ease-in-out yst-shadow-sm yst-p-8;

	&.noBackground {
		@apply yst-bg-transparent yst-border-none yst-shadow-none yst-p-0;
	}
}

.toastRoot {
	@apply yst-fixed yst-left-6 yst-bottom-6 yst-space-y-2;
}
